import { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/material';
import AISubmission from './components/AISubmission';
import PageHeader from 'shared/components/PageHeader';

const EnterprisePortal = (): ReactElement => (
  <>
    <PageHeader
      title="Enterprise Portal"
      description="Manage public submission tokens and share your AI governance policy"
    />
    <Box className="dashboard-page enterprise-portal">
      <HeadTag title="Enterprise Portal" />

      <Box className="submission-enterprise-wrapper">
        <Box className="submission-portal">
          <AISubmission />
        </Box>
      </Box>
    </Box>
  </>
);

export default EnterprisePortal;
